import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
// import { MemberProxyService } from '../../service/member-proxy.service';
import { GlobalComponentService } from '@techmore/global';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { removeUrlQueryParam } from 'src/app/util';

@Component({
  selector: 'app-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: [
    '../../module/culture-center-member/member-loading-culture-center/member-loading-culture-center.component.css',
    './sign-out.component.scss'
  ]
})
export class SignOutComponent implements OnInit {
  constructor(
    // private memberProxyService: MemberProxyService,
    private globalComponentService: GlobalComponentService,
    private render: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private serverConfigService: ServerConfigService,
  ) { }

  ngOnInit() {
    this.render.setAttribute(this.document.head.querySelector('link[rel="canonical"]'), 'href', removeUrlQueryParam(this.serverConfigService.getCurrentUrl()));
    this.render.setAttribute(this.document.head.querySelector('meta[property="og:url"]'), 'content', removeUrlQueryParam(this.serverConfigService.getCurrentUrl()));
    this.render.setAttribute(this.document.head.querySelector('meta[name="twitter:url"]'), 'content', removeUrlQueryParam(this.serverConfigService.getCurrentUrl()));
    localStorage.removeItem('auth_code');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_refresh_token');
    localStorage.removeItem('auth_way');
    this.globalComponentService.openInfoAlert('已登出，請關閉視窗', {
      afterClose: () => {
        window.close();
      }
    });

    // this.memberProxyService.logout().subscribe(() => {
    //   this.globalComponentService.openInfoAlert('登出成功');
    // }, error => {
    //   console.error(error);
    //   this.globalComponentService.openInfoAlert('登出失敗');
    // });
  }
}
